const images = {
    SmadavProtect : require('./SmadavProtect.png'),
    SmadavWhite: require('./SmadavProtectWhite.png'),
    SmadavAllWhite: require('./SmadavAllWhite.png'),
    Smadav : require('./Smadav.png'),
    photopp : require('./photopp.webp'),
    tenorBg : require('./tenor.gif'),
    noresult: require('./no_result_found.gif')
}

export default images